module.exports = __webpack_public_path__ + "static/media/Icon_event_asesoria.28764e51.svg";